import { api } from './config';
import { ApiResponse, AuthResponse, OAuthRequest } from '../types';

export const authApi = {
  sendVerificationCode: (email: string, purpose: string) =>
    api.post<ApiResponse>('/auth/send-verification-code', { email, purpose }),

  verifyVerificationCode: (email: string, code: string) =>
    api.post<AuthResponse>('/auth/verify-code', { email, code }),

  adminLogin: (email: string, password: string) =>
    api.post<AuthResponse>('/auth/admin/login', { email, password }),

  brandLogin: (email: string, password: string) =>
    api.post<AuthResponse>('/auth/brand/login', { email, password }),

  refresh: () => api.post<AuthResponse>('/auth/refresh', {}, {
    withCredentials: true,
    headers: { 'X-Skip-Interceptor': 'true' }
  }),

  logout: () => api.post<ApiResponse>('/auth/logout'),

  registerBrand: (data: {
    email: string;
    registration_token: string;
    company_name: string;
    contact_person: string;
    phone?: string;
  }) => api.post<ApiResponse>('/auth/register-brand', data),

  oauthLogin: (data: OAuthRequest) =>
    api.post<AuthResponse>('/auth/oauth', data),
};
